/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/cart/custom-elements';

import { defineCustomElement as defineOsdsCart } from '@ovhcloud/ods-stencil/components/cart/custom-elements/osds-cart.js';
import { defineCustomElement as defineOsdsCartFooter } from '@ovhcloud/ods-stencil/components/cart/custom-elements/osds-cart-footer.js';
import { defineCustomElement as defineOsdsCartFooterItem } from '@ovhcloud/ods-stencil/components/cart/custom-elements/osds-cart-footer-item.js';
import { defineCustomElement as defineOsdsCartHeader } from '@ovhcloud/ods-stencil/components/cart/custom-elements/osds-cart-header.js';
import { defineCustomElement as defineOsdsCartItem } from '@ovhcloud/ods-stencil/components/cart/custom-elements/osds-cart-item.js';
import { defineCustomElement as defineOsdsCartItemOption } from '@ovhcloud/ods-stencil/components/cart/custom-elements/osds-cart-item-option.js';
import { defineCustomElement as defineOsdsCartManager } from '@ovhcloud/ods-stencil/components/cart/custom-elements/osds-cart-manager.js';
import { defineCustomElement as defineOsdsCartSection } from '@ovhcloud/ods-stencil/components/cart/custom-elements/osds-cart-section.js';
import { defineCustomElement as defineOsdsCartTotal } from '@ovhcloud/ods-stencil/components/cart/custom-elements/osds-cart-total.js';


export const OsdsCart = /*@__PURE__*/ defineContainer<JSX.OsdsCart>('osds-cart', defineOsdsCart, [
  'size',
  'flex',
  'rounded',
  'collapsed',
  'collapsible'
]);


export const OsdsCartFooter = /*@__PURE__*/ defineContainer<JSX.OsdsCartFooter>('osds-cart-footer', defineOsdsCartFooter);


export const OsdsCartFooterItem = /*@__PURE__*/ defineContainer<JSX.OsdsCartFooterItem>('osds-cart-footer-item', defineOsdsCartFooterItem);


export const OsdsCartHeader = /*@__PURE__*/ defineContainer<JSX.OsdsCartHeader>('osds-cart-header', defineOsdsCartHeader, [
  'headerTitle'
]);


export const OsdsCartItem = /*@__PURE__*/ defineContainer<JSX.OsdsCartItem>('osds-cart-item', defineOsdsCartItem);


export const OsdsCartItemOption = /*@__PURE__*/ defineContainer<JSX.OsdsCartItemOption>('osds-cart-item-option', defineOsdsCartItemOption);


export const OsdsCartManager = /*@__PURE__*/ defineContainer<JSX.OsdsCartManager>('osds-cart-manager', defineOsdsCartManager, [
  'size',
  'flex',
  'sections',
  'footer',
  'vatMode',
  'period',
  'i18n'
]);


export const OsdsCartSection = /*@__PURE__*/ defineContainer<JSX.OsdsCartSection>('osds-cart-section', defineOsdsCartSection);


export const OsdsCartTotal = /*@__PURE__*/ defineContainer<JSX.OsdsCartTotal>('osds-cart-total', defineOsdsCartTotal);

